import { IconBuilding } from "@tabler/icons";

const icons = {
  IconBuilding,
};

const branchManagement = {
  id: "branchManagement",
  type: "group",
  title: "Branch Management",
  children: [
    {
      id: "branch-management",
      title: "Branches",
      type: "item",
      url: "/branches",
      icon: icons.IconBuilding,
    },
    {
      id: "branch",
      title: "Add Branch",
      type: "item",
      url: "/branch/add",
      icon: icons.IconBuilding,
    },
  ],
};

export default branchManagement;
